import React from "react";
import SpotLoadDetail from "../../spotLoads/partials/SpotLoadDetail";
import AlpSpotLoadDetail from "../../alpSpotLoads/partials/AlpSpotLoadDetail";
import AlpInboundLoadDetail from "../../alpInboundLoads/AlpInboundLoadDetail";
import AlpOutboundLoadDetail from "../../alpOutboundLoads/AlpOutboundLoadDetail";
import AlpReexportLoadDetail from "../../alpReexportLoads/AlpReexportLoadDetail";
import AlpAvisoOutboundGroupDetailPage from "../../alpAvisoOutboundGroups/partials/AlpAvisoOutboundGroupDetailPage";

// Shows the right detail view based on load type (used from unified LoadList)
const LoadListDetailPanel = (props: any) => {
    const {
        loadType,
        operation,
        operationId,
        onClose,
        toastify,
        dropdowns,
        setQuery,
    } = props;

    const params = {
        operation,
        operationId,
    };

    if ( loadType === 'SpotLoad' ) {
        return (
            <SpotLoadDetail
                params={ params }
                toastify={ toastify }
                onClose={ onClose }
            />
        );
    }

    if ( loadType === 'AlpSpotLoad' ) {
        return (
            <AlpSpotLoadDetail
                params={ params }
                toastify={ toastify }
                dropdowns={ dropdowns }
                setQuery={ setQuery }
                onClose={ onClose }
            />
        );
    }

    if ( loadType === 'AlpInboundLoad' ) {
        return (
            <AlpInboundLoadDetail
                params={ params }
                toastify={ toastify }
                dropdowns={ dropdowns }
                setQuery={ setQuery }
                onClose={ onClose }
            />
        );
    }

    if ( loadType === 'AlpOutboundLoad' ) {
        return (
            <AlpOutboundLoadDetail
                params={ params }
                toastify={ toastify }
                dropdowns={ dropdowns }
                setQuery={ setQuery }
                onClose={ onClose }
            />
        );
    }

    if ( loadType === 'AlpReexportLoad' ) {
        return (
            <AlpReexportLoadDetail
                params={ params }
                toastify={ toastify }
                dropdowns={ dropdowns }
                setQuery={ setQuery }
                onClose={ onClose }
            />
        );
    }

    if ( loadType === 'AlpOutboundLoadGroup' ) {
        return (
            <AlpAvisoOutboundGroupDetailPage
                toastify={ toastify }
                groupToken={ operationId }
                onClose={ onClose }
            />
        );
    }

    return null;
};

export default LoadListDetailPanel;
